import React from 'react';
import Highlight from 'react-highlight';
import XMLViewer from '../../libs/react-xml-viewer';

const viewerStyle = { minHeight: 120, maxHeight: 480 };

const isValidXml = (data) => {
  if (typeof data !== 'string' || !data.trim()) {
    return false;
  }
  const domParser = new DOMParser();
  const dom = domParser.parseFromString(data, 'text/xml');
  return !dom.getElementsByTagName('parsererror').length;
};

/**
 * Collapsible XML tree (react-xml-viewer), aligned with Auction Snapshot XmlViewer.
 * Falls back to syntax-highlighted text if the string is not well-formed XML.
 */
export default function XmlTreeView({ xml }) {
  if (isValidXml(xml)) {
    return (
      <div data-testid="xml-tree-view" style={{ maxHeight: 480, overflow: 'auto' }}>
        <XMLViewer xml={xml} style={viewerStyle} collapsible overflowBreak />
      </div>
    );
  }
  return <Highlight className="xml">{xml}</Highlight>;
}
